import { notifications } from '@mantine/notifications';
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next';

export const mutateChangelogCreate = () => {
    const { t } = useTranslation();

    const mutation = useMutation({
        mutationKey: ['changelog-create'],
        mutationFn: async (formData) => {
            const res = await axios.post(route('studio.v1.api.changelog.store'), formData);
            return res;
        },
        onSuccess: async () => {
            notifications.show({
                color: 'green',
                title: t('common.success'),
                message: t('changelog.entry.created'),
            })
        },
        onError: async ({ response }) => {
            notifications.show({
                color: 'red',
                title: t('common.error'),
                message: response?.data?.message || "",
            })
        }
    });

    return mutation;
}
